import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import { getTravels } from "../services/getData";
import { getEquipmentsByType } from "../../../services/equipmentsAPI";
import {
  transformSelectFormat,
  transformSelectToList,
} from "../../../utils/transformFormatSelect";
import LoadEditorUpdateModal from "./LoadEditorUpdateModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse, subDays } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import Header from "../../../components/header";
import { DeleteTravelById } from "../services/Insert&UpdateTravel";
import { exportToExcel } from "../../../services/exportToXlsx";

const LoadEditorTravelTable = ({
  allTruckList,
  allShovelList,
  allOriginList,
  allDestinationList,
  allMaterialList,
  allShift,
  allTravelTypes,
  allTravelStatus,
  allMaterialBlock,
  allMaterialClass,
  allPitLevel,
  permissionUpdate,
  permissionDelete,
  actualShift,
  configInputs,
  allRehandle,
}) => {
  const [selectedTruck, setSelectedTruck] = useState([]);
  const [selectedTruckByApi, setSelectedTruckByApi] = useState(null);
  const [selectedShovel, setSelectedShovel] = useState([]);
  const [selectedShovelByApi, setSelectedShovelByApi] = useState([]);

  const [selectedOrigin, setSelectedOrigin] = useState([]);
  const [selectedOriginByApi, setSelectedOriginByApi] = useState([]);
  const [selectedDestination, setSelectedDestination] = useState([]);
  const [selectedDestinationByApi, setSelectedDestinationByApi] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState([]);
  const [selectedMaterialByApi, setSelectedMaterialByApi] = useState([]);
  const [selectedShift, setSelectedShift] = useState([]);
  const [selectedShiftByApi, setSelectedShiftByApi] = useState([]);

  const [selectedShiftDate, setSelectedShiftDate] = useState(null);
  const [selectedShiftDatePicker, setSelectedShiftDatePicker] = useState(null);
  const [minSelectedShiftDatePicker, setMinSelectedShiftDatePicker] =
    useState(null);
  const [maxSelectedShiftDatePicker, setMaxSelectedShiftDatePicker] =
    useState(null);

  const [selectedTravelTypes, setSelectedTravelTypes] = useState([]);
  const [selectedTravelTypesByApi, setSelectedTravelTypesByApi] = useState([]);

  const [selectedTravelStatus, setSelectedTravelStatus] = useState([]);

  const [allTravels, setAllTravels] = useState([]);
  const [columnsDatatable, setColumnsDatatable] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [travelIdModal, setTravelIdModal] = useState(null);
  const [realoadTable, setRealoadTable] = useState(false);

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#1c4b64", // por ejemplo, Tailwind gray-800
        color: "white",
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  };

  useEffect(() => {
    if (!actualShift) return;
    //console.log("La fecha actual es:", actualShift);
    setSelectedShiftDate(actualShift);

    const safeDate = parse(actualShift, "yyyy-MM-dd", new Date());
    //console.log("La fecha de datapiker es: ", safeDate);
    setSelectedShiftDatePicker(safeDate);
    const minDate = subDays(safeDate, configInputs.shift_date.min_value);
    //console.log("La fecha minima es: ", minDate);
    setMaxSelectedShiftDatePicker(safeDate);
    setMinSelectedShiftDatePicker(minDate);
  }, [actualShift, configInputs]);

  useEffect(() => {
    if (!actualShift || !selectedShiftDate) return;
    fetchTravels();
    let columns = [
      {
        name: "Date",
        selector: (row) =>
          formatInTimeZone(new Date(row.date), "UTC", "yyyy-MM-dd"),
        sortable: true,
      },
      {
        name: "Truck",
        selector: (row) => row.equipment,
        sortable: true,
      },
      {
        name: "Shovel",
        selector: (row) => row.shovel,
        sortable: true,
        conditionalCellStyles: [
          {
            when: (row) =>
              row.shovel == "No equipment" &&
              (row.travel_type_name == "TBC" ||
                row.travel_type_name == "Loaded"), // o cualquier otra condición
            style: (row) => ({
              backgroundColor: "#d94c4c",
            }),
          },
        ],
      },
      {
        name: "Origin",
        selector: (row) => row.origin,
        sortable: true,
      },
      {
        name: "Destination",
        selector: (row) => row.destination,
        sortable: true,
      },
      {
        name: "Dump Time",
        selector: (row) =>
          formatInTimeZone(new Date(row.stamp_time), "UTC", "HH:mm:ss"),
        sortable: true,
      },
    ];
    if (configInputs.material_block.is_show) {
      columns.push({
        name: "Material Block",
        selector: (row) => row.material_block_name,
        sortable: true,
        conditionalCellStyles: [
          {
            when: (row) =>
              row.material_block_name == "No_Block_Name" &&
              (row.travel_type_name == "TBC" ||
                row.travel_type_name == "Loaded"), // o cualquier otra condición
            style: (row) => ({
              backgroundColor: "#d94c4c",
            }),
          },
        ],
      });
    }
    columns.push({
      name: "Material",
      selector: (row) => row.material_name,
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) =>
            row.material_name == "No material" &&
            (row.travel_type_name == "TBC" || row.travel_type_name == "Loaded"), // o cualquier otra condición
          style: (row) => ({
            backgroundColor: "#d94c4c",
          }),
        },
      ],
    });
    if (configInputs.material_class.is_show) {
      columns.push({
        name: "Material Class",
        selector: (row) => row.material_class,
        sortable: true,
        conditionalCellStyles: [
          {
            when: (row) =>
              row.material_class == "No material class" &&
              (row.travel_type_name == "TBC" ||
                row.travel_type_name == "Loaded"), // o cualquier otra condición
            style: (row) => ({
              backgroundColor: "#d94c4c",
            }),
          },
        ],
      });
    }
    if (configInputs.pit_level.is_show) {
      columns.push({
        name: "Pit Level",
        selector: (row) => row.pit_level_material,
        sortable: true,
        conditionalCellStyles: [
          {
            when: (row) =>
              row.pit_level_material == "Without factor" &&
              (row.travel_type_name == "TBC" ||
                row.travel_type_name == "Loaded"), // o cualquier otra condición
            style: (row) => ({
              backgroundColor: "#d94c4c",
            }),
          },
        ],
      });
    }
    if (configInputs.density.is_show) {
      columns.push({
        name: "Density",
        selector: (row) => row.pit_level_material,
        sortable: true,
      });
    }
    columns.push(
      {
        name: "Shift",
        selector: (row) => row.shift,
        sortable: true,
      },
      {
        name: "Travel Type",
        selector: (row) => row.travel_type_name,
        sortable: true,
        conditionalCellStyles: [
          {
            when: (row) => row.travel_type_name == "TBC", // o cualquier otra condición
            style: (row) => ({
              backgroundColor: "#d94c4c",
            }),
          },
        ],
      },
      {
        name: "Ext",
        selector: (row) => row.extraload,
        sortable: true,
      }
    );
    if (configInputs.grade1.is_show) {
      columns.push({
        name: "Grade 1",
        selector: (row) => row.grade_1,
        sortable: true,
      });
    }
    if (configInputs.grade2.is_show) {
      columns.push({
        name: "Grade 2",
        selector: (row) => row.grade_2,
        sortable: true,
      });
    }
    if (configInputs.rehandle.is_show) {
      columns.push({
        name: "Rhd",
        selector: (row) => row.rehandle,
        sortable: true,
      });
    }
    columns.push({
      name: "Tons",
      selector: (row) => row.payload,
      sortable: true,
    });
    if (permissionUpdate) {
      columns.push({
        name: "Update",
        cell: (row) => (
          <button
            onClick={() => handleEdit(row)}
            className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 text-xs"
          >
            Edit
          </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      });
    }
    if (permissionDelete) {
      columns.push({
        name: "Delete",
        cell: (row) => (
          <button
            onClick={() => deleteTravel(row)}
            className="bg-red-500 text-white px-2 py-1 rounded hover:bg-delete-600 text-xs"
          >
            Delete
          </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      });
    }

    setColumnsDatatable(columns);
  }, [
    selectedTruckByApi,
    selectedShovelByApi,
    selectedOriginByApi,
    selectedDestinationByApi,
    permissionUpdate,
    selectedShiftByApi,
    selectedTravelTypesByApi,
    selectedShiftDate,
    realoadTable,
    showModal,
  ]);

  const handleExport = () => {
    exportToExcel(allTravels, "mi_tabla.xlsx");
  };
  const fetchTravels = async () => {
    try {
      //setSelectedShiftDatePicker(actualShift)
      //console.log(actualShift);
      const result_travels = await getTravels(
        selectedShiftDate,
        selectedTruckByApi,
        selectedShovelByApi,
        selectedOriginByApi,
        selectedDestinationByApi,
        null,
        selectedShiftByApi,
        selectedTravelTypesByApi
      );
      if (result_travels) {
        //console.log(result_travels);
        setAllTravels(result_travels.info_travelss);
      }
    } catch (error) {
      //console.error("Error fetching reasons:", error);
      var aux = 0;
    }
  };

  const handleFilterTravels = async (
    selectedOption,
    setSelected,
    setSelectedByApi
  ) => {
    //console.log(selectedOption);
    let result_list = await transformSelectToList(selectedOption);
    //console.log(result_list);

    if (result_list.status === 200) {
      setSelectedByApi(result_list.data);
    }
    setSelected(selectedOption);
  };
  const handleEdit = async (event) => {
    //console.log("Se va a editar");
    //console.log(event);
    //console.log("Categoría seleccionada:", value);
    setShowModal(true);
    setTravelIdModal(event.travel_id);
  };

  const handleDateFilter = async (event) => {
    //console.log("Se va a filtrar fecha");
    //console.log(event);
    let formatted = format(event, "yyyy-MM-dd");
    //console.log(formatted);
    setSelectedShiftDate(formatted);
    setSelectedShiftDatePicker(event);
  };

  const deleteTravel = async (event) => {
    //console.log("Se va a eliminar el viaje");
    //console.log(event);
    let time_stamp_aux = formatInTimeZone(
      new Date(event.stamp_time),
      "UTC",
      "HH:mm:ss"
    );
    const result = await Swal.fire({
      title: "Are you sure?",
      text:
        "The travel made by truck " +
        event.equipment +
        " at " +
        time_stamp_aux +
        " will be deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
      customClass: {
        confirmButton:
          "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
        cancelButton:
          "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded ml-2",
      },
      buttonsStyling: false,
    });

    if (result.isConfirmed) {
      const result_delete = await DeleteTravelById(event.travel_id);
      if (result_delete.status == 200) {
        const result_delete_m = await Swal.fire({
          title: "Travel was deleted",
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton:
              "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
          },
          buttonsStyling: false,
        });

        if (result_delete_m.isConfirmed) {
          setRealoadTable(!realoadTable);
        }
      }
    }
  };

  const conditionalRowStyles = [
    {
      when: (row) => row.travel_type_name === "TBC",
      style: {
        boxShadow: "0 0 0 2px red inset",
      },
    },
  ];

  return (
    <div className="m-10 bg-gray-300">
      <Header title={`Travels`} />
      <div class="mx-2 my-5 grid grid-cols-4 gap-4">
        <div class="col-span-1">
          <label class=" tracking-wide text-xs font-bold mb-2">Truck</label>
          <div class="relative">
            <Select
              isMulti
              value={selectedTruck}
              onChange={(selectedOption) =>
                handleFilterTravels(
                  selectedOption,
                  setSelectedTruck,
                  setSelectedTruckByApi
                )
              }
              options={allTruckList}
            />
          </div>
        </div>
        <div class="col-span-1">
          <label class=" tracking-wide text-xs font-bold mb-2">Shovel</label>
          <div class="relative">
            <div class="relative">
              <Select
                isMulti
                value={selectedShovel}
                onChange={(selectedOption) =>
                  handleFilterTravels(
                    selectedOption,
                    setSelectedShovel,
                    setSelectedShovelByApi
                  )
                }
                options={allShovelList}
              />
            </div>
          </div>
        </div>
        <div class="col-span-1">
          <label class=" tracking-wide text-xs font-bold mb-2">Origin</label>
          <div class="relative">
            <Select
              isMulti
              value={selectedOrigin}
              onChange={(selectedOption) =>
                handleFilterTravels(
                  selectedOption,
                  setSelectedOrigin,
                  setSelectedOriginByApi
                )
              }
              options={allOriginList}
            />
          </div>
        </div>
        <div class="col-span-1">
          <label class=" tracking-wide text-xs font-bold mb-2">
            Destination
          </label>
          <div class="relative">
            <Select
              isMulti
              value={selectedDestination}
              onChange={(selectedOption) =>
                handleFilterTravels(
                  selectedOption,
                  setSelectedDestination,
                  setSelectedDestinationByApi
                )
              }
              options={allDestinationList}
            />
          </div>
        </div>
      </div>
      <div class="mx-2 my-5 grid grid-cols-5 gap-4">
        <div class="col-span-1">
          <label class=" tracking-wide text-xs font-bold mb-2">Material</label>
          <div class="relative">
            <Select
              isMulti
              value={selectedMaterial}
              onChange={(selectedOption) =>
                handleFilterTravels(
                  selectedOption,
                  setSelectedMaterial,
                  setSelectedMaterialByApi
                )
              }
              options={allMaterialList}
            />
          </div>
        </div>
        <div class="col-span-1">
          <label class=" tracking-wide text-xs font-bold mb-2">Shift</label>
          <div class="relative">
            <Select
              isMulti
              value={selectedShift}
              onChange={(selectedOption) =>
                handleFilterTravels(
                  selectedOption,
                  setSelectedShift,
                  setSelectedShiftByApi
                )
              }
              options={allShift}
            />
          </div>
        </div>
        <div class="col-span-1">
          <label class=" tracking-wide text-xs font-bold mb-2 block">
            Date
          </label>
          <div class="relative">
            <DatePicker
              selected={selectedShiftDatePicker}
              onChange={(date) => handleDateFilter(date)}
              minDate={minSelectedShiftDatePicker}
              maxDate={maxSelectedShiftDatePicker}
              dateFormat="yyyy/MM/dd"
              placeholderText="YYYY/MM/DD"
              className="!w-full border border-gray-300 rounded-md px-0 py-1.5"
              wrapperClassName="w-full"
            />
          </div>
        </div>
        <div class="col-span-1">
          <label class=" tracking-wide text-xs font-bold mb-2">
            Travel Type
          </label>
          <div class="relative">
            <Select
              isMulti
              value={selectedTravelTypes}
              onChange={(selectedOption) =>
                handleFilterTravels(
                  selectedOption,
                  setSelectedTravelTypes,
                  setSelectedTravelTypesByApi
                )
              }
              options={allTravelTypes}
            />
          </div>
        </div>
        <div class="col-span-1">
          <label class=" tracking-wide text-xs font-bold mb-2">
            Travel Status
          </label>
          <div class="relative">
            <Select
              isMulti
              value={selectedDestination}
              onChange={(selectedOption) =>
                handleFilterTravels(
                  selectedOption,
                  setSelectedDestination,
                  setSelectedDestinationByApi
                )
              }
              options={allDestinationList}
            />
          </div>
        </div>
      </div>
      <div class="mx-2 my-5 grid grid-cols-1 gap-4">
        <div class="col-span-1">
          <button
            onClick={handleExport}
            className="px-6 py-3 bg-blue-500 text-white"
            style={{ width: "100%" }}
          >
            Export to xlsx
          </button>
        </div>
      </div>

      <DataTable
        columns={columnsDatatable}
        data={allTravels}
        pagination
        paginationPerPage={30}
        highlightOnHover
        striped
        responsive
        customStyles={customStyles}
        conditionalRowStyles={conditionalRowStyles}
      />
      {showModal && (
        <LoadEditorUpdateModal
          setShowModal={setShowModal}
          travel_id={travelIdModal}
          configInputs={configInputs}
          allTruckList={allTruckList}
          allShovelList={allShovelList}
          allOriginList={allOriginList}
          allDestinationList={allDestinationList}
          allMaterialList={allMaterialList}
          allTravelTypes={allTravelTypes}
          allMaterialBlock={allMaterialBlock}
          allMaterialClass={allMaterialClass}
          allPitLevel={allPitLevel}
          allRehandle={allRehandle}
        />
      )}
    </div>
  );
};

export default LoadEditorTravelTable;
